import {Animated, View} from 'react-native';
import React, {useCallback, useRef} from 'react';
import {images} from '../../../assets/icons';
import {useStyles} from '../../hooks/styles';
import {Props} from './model';

const frames = images.Loader.length;
const range = images.Loader.map((_, i) => i);
const firstAnimValue = 1 / frames;

export default ({size = 100}: Props) => {
  const duration = 2000;
  const framesAnim = useRef(new Animated.Value(firstAnimValue)).current;

  const runAnimation = useCallback(() => {
    framesAnim.setValue(firstAnimValue);
    Animated.timing(framesAnim, {
      toValue: frames,
      useNativeDriver: true,
      duration,
      easing: (v) => {
        return Math.floor(v * frames) / frames;
      },
    }).start(() => runAnimation());
  }, []);

  React.useEffect(() => {
    runAnimation();
  }, []);

  const styles = useStyles(() => ({
    image: {
      position: 'absolute',
      left: 0,
      right: 0,
      width: size,
      height: size,
    },
    container: {
      position: 'relative',
    },
  }));

  const getOpacity = React.useCallback(
    (num: number) => {
      const outputRange = new Array(range.length).fill(0);
      outputRange[num] = 1;
      return framesAnim.interpolate({
        inputRange: range,
        outputRange,
      });
    },
    [framesAnim],
  );
  return (
    <View style={[styles.container, {width: size, height: size}]}>
      {range.map((item) => {
        const Image = images.Loader[item];
        return (
          <Animated.View style={[styles.image, {opacity: getOpacity(item)}]} key={item}>
            <Image width={size} height={size} />
          </Animated.View>
        );
      })}
    </View>
  );
};
